import { render, staticRenderFns } from "./MoreContentUnit.vue?vue&type=template&id=1c6a0167&scoped=true&"
import script from "./MoreContentUnit.vue?vue&type=script&lang=js&"
export * from "./MoreContentUnit.vue?vue&type=script&lang=js&"
import style0 from "./MoreContentUnit.vue?vue&type=style&index=0&id=1c6a0167&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6a0167",
  null
  
)

export default component.exports